import React, {useState, useEffect} from 'react';
import {useNavigate, useLocation} from "react-router-dom";
import ButtonHint from "../../../../components/Buttons/buttonHint/ButtonHint";
import CustomAlert from "../../../../components/CustomAlert/CustomAlert";
import {MEDIA} from "../../../../utils/js/Const";
import {usePatchAssembledOrder} from "../../hooks/usePatchAssembledOrder/usePatchAssembledOrder";

const OrderDetailsBase = ({detailInformation, statuses_id}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {patchAssembledOrder, loading, error} = usePatchAssembledOrder();

    const [alertState, setAlertState] = useState({
        isOpen: false, title: '', message: '', statusCod: '', isSuccess: false,
    });

    const showAlert = (title, message, statusCod, isSuccess = false) => {
        setAlertState({isOpen: true, title, message, statusCod, isSuccess});
    };

    const closeAlert = () => {
        const wasSuccess = alertState.isSuccess;
        setAlertState(prev => ({...prev, isOpen: false}));

        if (wasSuccess) {
            navigate(location.pathname, {
                state: {
                    ...location.state,
                    statuses_id: 2,
                },
                replace: true,
            });
        }
    };

    useEffect(() => {
        if (error) {
            showAlert(error.title || 'Ошибка', error.message, error.statusCode);
        }
    }, [error]);

    const handleTakeOrder = async () => {
        try {
            await patchAssembledOrder(detailInformation?.guid);
            showAlert(
                'Успех',
                'Вы успешно взяли заказ',
                200,
                true
            );
        } catch (err) {
            console.error('Ошибка принятия заказа:', err);
        }
    };

    const formatDateTime = (isoString) => {
        if (!isoString) return '';
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return '';

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${hours}:${minutes} ${day}.${month}.${year}`;
    };

    console.log("detailInformation",detailInformation)

    return (
        <div className="order_details-list">
            <CustomAlert
                title={alertState.title}
                message={alertState.message}
                statusCod={alertState.statusCod}
                isOpenAlert={alertState.isOpen}
                onClose={closeAlert}
            />

            <div className={"title"}>Заказ</div>

            <div className={"order_details-list--header"}>
                <div>Заказ №: {detailInformation?.guid?.split('-')[2]}</div>
                <div>от {formatDateTime(detailInformation.datetime_create)}</div>
            </div>

            <div className={"order_details-list--body"}>
                <div className={"name"}>Товары:</div>
                {detailInformation?.goods?.map((order) => (
                    <div className={"item"} key={order.guid}>
                        <div className={"item-img_name"}>
                            <img
                                className={"item-img_name-img"}
                                src={`${MEDIA}/api/attachments/${order?.attachments_guid_array}`}
                                alt={order.name}
                            />
                            <div className={"item-img_name-name"}>{order.name}</div>
                        </div>

                        <div className={"item-price"}>
                            <div className={"current-price"}>{order.current_price}₽</div>
                            {order.old_price > 0 && (
                                <div className={"old-price"}>{order.old_price}₽</div>
                            )}
                        </div>

                        <div className={"item-quantity"}>
                            <div>{order.quantity} {order.measure_name}</div>
                        </div>
                    </div>
                ))}
            </div>

            {Number(statuses_id) === 1 && (
                <ButtonHint
                    text={loading ? "Берём..." : "Взять заказ в сборку"}
                    className={"order_details-page-button"}
                    funck={loading ? undefined : handleTakeOrder}
                />
            )}
        </div>
    );
};

export default OrderDetailsBase;